Backbone = require 'backbone'

class FAQSearchModel extends Backbone.Model
  initialize: ->
    @baseUrl = "#{window.FAQBASEURL}/search"

  setUrl : (searchText) ->
    searchText = encodeURIComponent(searchText)
    @url = "#{@baseUrl}?should_display_cms_content=#{experiments.shouldDisplayCMSContentForUS}&search_text=#{searchText}"

module.exports = FAQSearchModel
